import { Text } from '@react-three/drei'
import { IContainer } from './Container'

const DimensionAxis = ({ containerSize }: { containerSize: IContainer }) => {
    const markX = Array.from({ length: Math.floor(containerSize.w) + 1 }, (_, i) => i)
    const markY = Array.from({ length: Math.floor(containerSize.h) + 1 }, (_, i) => i)
    const markZ = Array.from({ length: Math.floor(containerSize.d) + 1 }, (_, i) => i)
    if (Math.abs(markX[markX.length - 1] - containerSize.w) > 0.0001) {
        markX.push(containerSize.w)
    }
    if (Math.abs(markY[markY.length - 1] - containerSize.h) > 0.0001) {
        markY.push(containerSize.h)
    }
    if (Math.abs(markZ[markZ.length - 1] - containerSize.d) > 0.0001) {
        markZ.push(containerSize.d)
    }

    return (
        <group>
            {/* X축 눈금 */}
            {markX.map((meter, i) => {
                const x = -containerSize.w / 2 + meter
                return (
                    <group key={`x-${i}`}>
                        <mesh position={[x, 0.05 / 2, containerSize.d / 2]}>
                            <boxGeometry args={[0.02, 0.05, 0.02]} />
                            <meshStandardMaterial color={'black'} />
                        </mesh>
                        <Text
                            position={[x, 0, containerSize.d / 2 + (i === markX.length - 1 ? 0.2 : 0.05)]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            fontSize={0.2}
                            color={'black'}
                            anchorX="center"
                            anchorY="top"
                        >
                            {i === markX.length - 1 ? meter.toFixed(3) : Math.round(meter).toString()}m
                        </Text>
                    </group>
                )
            })}

            {/* Y축 눈금 */}
            {markY.map((meter, i) => {
                const y = meter
                return (
                    <group key={`y-${i}`}>
                        {/* 눈금선: Y축 따라 수직 배치 */}
                        <mesh position={[containerSize.w / 2, y, containerSize.d / 2]}>
                            <boxGeometry args={[0.02, 0.02, 0.02]} />
                            <meshStandardMaterial color={'black'} />
                        </mesh>
                        <Text
                            position={[
                                containerSize.w / 2 + 0.05, // X축 옆으로 살짝 띄움
                                y,
                                containerSize.d / 2,
                            ]}
                            rotation={[0, 0, 0]} // 텍스트 수직 유지 (필요하면 회전도 가능)
                            fontSize={0.2}
                            color={'black'}
                            anchorX="left"
                            anchorY="middle"
                        >
                            {i === markY.length - 1 ? meter.toFixed(3) : Math.round(meter).toString()}m
                        </Text>
                    </group>
                )
            })}

            {/* Z축 눈금 */}
            {markZ.map((meter, i) => {
                const z = -containerSize.d / 2 + meter
                return (
                    <group key={`z-${i}`}>
                        <mesh position={[containerSize.w / 2, 0.05 / 2, z]}>
                            <boxGeometry args={[0.02, 0.05, 0.02]} />
                            <meshStandardMaterial color={'black'} />
                        </mesh>
                        <Text
                            position={[containerSize.w / 2 + (i === markZ.length - 1 ? 0.4 : 0.2), 0, z]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            fontSize={0.2}
                            color={'black'}
                            anchorX="center"
                            anchorY="top"
                        >
                            {i === markZ.length - 1 ? meter.toFixed(3) : Math.round(meter).toString()}m
                        </Text>
                    </group>
                )
            })}
        </group>
    )
}

export default DimensionAxis